import { render, staticRenderFns } from "./DashboardName.vue?vue&type=template&id=06bb1ff6&scoped=true&v-on-clickaway=cancel&"
import script from "./DashboardName.vue?vue&type=script&lang=ts&"
export * from "./DashboardName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bb1ff6",
  null
  
)

export default component.exports